<template>
  <div class="mainCommonListContainer">
    <div class="buttonContainer">
      <div class="addDiv">
        <el-button @click="add()" v-if="null !== addPermission" class="addBtn"
          >{{ addPermission.name }}<i class="el-icon-plus el-icon--right"></i
        ></el-button>
      </div>

      <div id="queryDiv">
        <el-form :model="queryForm" @submit.native.prevent>
          <el-form-item label="">
            <el-input
              v-model="queryForm.name"
              placeholder="搜索飞机名称"
              @keyup.enter.native="handleCurrentChange(1)"
              ><i
                class="el-icon-search"
                slot="suffix"
                @click="handleCurrentChange(1)"
              >
              </i
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="mainTableContainer">
      <el-table
        class="table commonScrollTable"
        :data="tableData"
        height="491"
        style="width: 100%"
        ref="commonTable"
      >
        <el-table-column
          prop="name"
          label="名称"
          min-width="50"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="uas_serial_id"
          label="编号"
          min-width="50"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="company_name"
          label="公司"
          min-width="60"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="department_name"
          label="所属部门"
          min-width="60"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="uav_model_name"
          label="飞机型号名称"
          min-width="40"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="uav_type_name"
          label="飞机类型"
          min-width="40"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="contact"
          label="联系人"
          min-width="40"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          label="操作"
          min-width="80"
          align="center"
          v-if="buttonList.length !== 0"
        >
          <template slot-scope="scope">
            <div class="buttonCol">
              <div
                v-for="(button, index) in buttonList"
                :key="index"
                class="buttonClass"
              >
                <el-button
                  v-if="button.path === 'planeList-edit'"
                  @click="edit(scope.row)"
                  icon="el-icon-operte-view"
                  class="editBtn"
                  style="margin-right: 10px"
                  >{{ button.name }}</el-button
                ><el-button
                  v-else-if="button.path === 'planeList-del'"
                  @click="del(scope.row)"
                  icon="el-icon-operte-view"
                  class="delBtn"
                  style="margin-right: 10px"
                  >{{ button.name }}</el-button
                >
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div
        style="
          text-align: right;
          margin-top: 15px;
          margin-right: 0px;
          height: 40px;
        "
        id="pages"
      >
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="current"
          :page-sizes="[6, 16, 24, 32]"
          :page-size="size"
          layout="total, sizes, prev, pager, next"
          :total="totalCount"
          popper-class="adminHomeSelect"
        ></el-pagination
        ><!-- , jumper -->
      </div>
    </div>

    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="818px"
      height="717px"
      class="commonScrollDialog"
    >
      <div class="dialog-header-separator"></div>
      <el-form
        :rules="rules"
        ref="commonForm"
        :model="commonForm"
        label-width="120px"
        @submit.native.prevent
      >
        <el-form-item prop="name" label="名称" class="left-form-item">
          <el-input
            v-model="commonForm.name"
            maxlength="50"
            placeholder="请输入飞机名称"
            @keyup.enter.native="submit('commonForm')"
          ></el-input>
        </el-form-item>
        <el-form-item prop="status" label="状态">
          <el-select
            v-model="commonForm.status"
            placeholder="请选择飞机状态"
            popper-class="adminHomeSelect"
          >
            <el-option
              v-for="planeStatus in planeStatuss"
              :key="planeStatus.id"
              :label="planeStatus.name"
              :value="planeStatus.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="department_id" label="部门" class="left-form-item">
          <el-select
            v-model="commonForm.department_id"
            placeholder="请选择部门"
            popper-class="adminHomeSelect"
            clearable
          >
            <el-option
              v-for="department in departments"
              :key="department.id"
              :label="department.name"
              :value="department.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="airborne_communication_id" label="机载链路">
          <el-select
            v-model="commonForm.airborne_communication_id"
            placeholder="请选择机载链路"
            popper-class="adminHomeSelect"
          >
            <el-option
              v-for="airborneCommunication in airborneCommunications"
              :key="airborneCommunication.id"
              :label="airborneCommunication.name"
              :value="airborneCommunication.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          prop="uas_serial_id"
          label="飞机编号"
          class="left-form-item"
        >
          <el-input
            v-model="commonForm.uas_serial_id"
            maxlength="200"
            placeholder="请输入飞机编号"
            @keyup.enter.native="submit('commonForm')"
          ></el-input>
        </el-form-item>
        <el-form-item prop="station_id" label="所属区域">
          <el-cascader
            v-model="commonForm.area_station"
            :options="areas"
            :props="{ expandTrigger: 'hover', value: 'id', label: 'value' }"
            @change="handleChange"
            popper-class="adminHomeCascader"
            clearable
          >
            <template slot-scope="{ data }">
              <span>{{ data.value }}</span>
            </template>
          </el-cascader>
        </el-form-item>
        <el-form-item prop="uav_model_id" label="型号" class="left-form-item">
          <el-select
            v-model="commonForm.uav_model_id"
            placeholder="请选择飞机型号"
            popper-class="adminHomeSelect"
          >
            <el-option
              v-for="uavModel in uavModels"
              :key="uavModel.id"
              :label="uavModel.name"
              :value="uavModel.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="user_id" label="飞机维护员">
          <el-select
            v-model="commonForm.user_id"
            placeholder="请选择飞机维护员"
            popper-class="adminHomeSelect"
          >
            <el-option
              v-for="user in users"
              :key="user.id"
              :label="user.username"
              :value="user.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="contact" label="联系人" class="left-form-item">
          <el-input
            v-model="commonForm.contact"
            maxlength="20"
            placeholder="请输入联系人"
            @keyup.enter.native="submit('commonForm')"
          ></el-input>
        </el-form-item>
        <el-form-item prop="phone" label="联系电话">
          <el-input
            v-model="commonForm.phone"
            placeholder="请输入联系电话"
            maxlength="11"
            @keyup.enter.native="submit('commonForm')"
          ></el-input>
        </el-form-item>

        <el-form-item class="formItemBtnRow">
          <el-button
            type="primary"
            @click="submit('commonForm')"
            class="confirmBtn"
            >确 定</el-button
          ><el-button @click="dialogVisible = false" class="cancelBtn"
            >取 消</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "planeList",
  props: ["menuId"],
  data() {
    // 联系电话验证
    const validatePhone = (rule, value, callback) => {
      if (value) {
        let regPhone = /^(13[0-9]|14[01456879]|15[0-3,5-9]|16[2567]|17[0-8]|18[0-9]|19[0-3,5-9])\d{8}$/; //11位手机号码正则
        if (!regPhone.test(value)) {
          regPhone = /0\d{2,3}-\d{7,8}(-\d{1,6})?/; //座机号码
          if (!regPhone.test(value)) {
            callback(new Error("联系电话格式不正确~"));
          } else {
            callback();
          }
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      queryForm: {},
      title: "添加飞机",
      options: [],
      addFlag: true,
      commonForm: {},
      current: 1, //当前页数
      size: 6, //显示几条
      totalCount: 0, //总条数
      tableData: [],
      dialogVisible: false,
      addPermission: null,
      buttonList: [],
      rules: {
        name: [{ required: true, message: "请输入飞机名称~", trigger: "blur" }],
        department_id: [{ required: false, trigger: "blur" }],
        contact: [{ required: false, trigger: "blur" }],
        station_id: [{ required: false, trigger: "blur" }],
        uas_serial_id: [
          { required: true, message: "请输入飞机编号~", trigger: "blur" },
        ],
        uav_model_id: [
          { required: true, message: "请选择飞机型号~", trigger: "blur" },
        ],
        airborne_communication_id: [
          { required: true, message: "请选择链路~", trigger: "blur" },
        ],
        user_id: [
          { required: true, message: "请选择飞机维护员~", trigger: "blur" },
        ],
        status: [
          { required: true, message: "请选择飞机状态~", trigger: "blur" },
        ],
        phone: [{ required: false, validator: validatePhone, trigger: "blur" }],
      },
      areas: [],
      users: [],
      uavModels: [],
      airborneCommunications: [],
      departments: [],
      planeStatuss: [
        {
          id: 0,
          name: "正常",
        },
        {
          id: 1,
          name: "测试",
        },
        {
          id: 2,
          name: "封存",
        },
        {
          id: 3,
          name: "修理",
        },
        {
          id: 4,
          name: "损坏",
        },
        {
          id: 5,
          name: "报废",
        },
      ],
    };
  },
  mounted() {
    this.setGutterWidth();
    this.query();
    this.buttonList = [];
    this.addPermission = null;
    this.$emit("getMenuList", this.menuId, 1, 0, this.getButtonList);
  },
  methods: {
    getButtonList(buttonList) {
      let menuId = this.menuId;
      for (
        let i = 0, len = buttonList.length;
        i < len && this.buttonList.length === 0;
        i++
      ) {
        let button = buttonList[i];
        if (button) {
          let children = button.children;
          if (children) {
            children.forEach((child) => {
              this.getChildren(child);
            });
          }
        }
      }
    },
    getChildren(item) {
      let menuId = item.id;
      let children = item.children;
      if (this.menuId === menuId) {
        let otherButton = [];
        for (let i = 0, len = children.length; i < len; i++) {
          let child = children[i];

          if (child) {
            if (child.path === "planeList-add") {
              this.addPermission = child;
            } else if (child.path !== "planeList-view") {
              otherButton.push(child);
            }
          }
        }
        this.buttonList = otherButton;
      } else {
        if (children) {
          children.forEach((child) => {
            this.getChildren(child);
          });
        }
      }
    },
    callOnTabSelect() {
      this.$nextTick(function () {
        this.$refs.commonTable.doLayout();
      });
    },
    resetStation(data) {
      if (!this.isEmptyArray(data)) {
        data.forEach((element) => {
          if (!this.isEmptyArray(element.children)) {
            element.children.forEach((e) => {
              e.id = e.id;
              e.value = e.name;
            });
          }
        });
      }
      return data;
    },
    handleChange(selectInfo) {
      if (selectInfo) {
        this.$data.commonForm.station_id = selectInfo[1];
      }
    },
    addPoint(type) {
      this.addOrReducePoint(type, true);
    },
    reducePoint(type) {
      this.addOrReducePoint(type, false);
    },
    add() {
      this.$data.title = "添加飞机";
      this.queryAllTypeInfos();
      this.$data.addFlag = true;
      this.$data.dialogVisible = true;
    },
    addStayPoint() {
      let vue = this;
      this.postJsonRequest(
        "/basic-info-server/uav/addUav.do",
        this.$data.commonForm
      )
        .then((res) => {
          res = res.data;
          if (null != res && 0 == res.code) {
            vue.$data.dialogVisible = false;
            vue.query();
            vue.$message({
              message: "提交成功",
              duration: 1000,
              customClass: "message-s",
              iconClass: "el-icon-ok-tip",
              offset: 470,
              onClose: function () {},
            });
          } else if (res.code != 401) {
            let msg = "请求失败";
            if (null != res) {
              msg = res.msg;
            }
            let tips = "<i class='el-icon-warn-tip'></i>" + msg;
            this.$confirm(tips, "提示", {
              confirmButtonText: "好的",
              customClass: "customClass-style",
              iconClass: "",
              dangerouslyUseHTMLString: true,
              confirmButtonClass: "confirm-style",
              showCancelButton: false,
            });
          }
        })
        .catch((error) => {});
    },
    queryAllTypeInfos() {
      this.queryAllArea();
      this.queryUavModel();
      this.queryAirborneCommunication();
      this.queryUsers();
      this.queryDepartment();
    },
    queryAllArea() {
      let vue = this;
      this.getRequest("/basic-info-server/station/getStationGroupByArea.do")
        .then((res) => {
          res = res.data;
          if (null != res && 0 == res.code) {
            if (!this.isEmptyArray(res.data)) {
              this.$data.areas = this.resetStation(res.data);
            } else {
              this.$data.areas = [];
            }
          } else if (res.code != 401) {
            // let msg = "请求数据失败";
            // if (!this.isEmptyStr(res.msg)) {
            //   msg = res.msg;
            // }
            // let tips = "<i class='el-icon-warn-tip'></i>" + msg;
            // this.$confirm(tips, "提示", {
            //   confirmButtonText: "好的",
            //   customClass: "customClass-style",
            //   iconClass: "",
            //   dangerouslyUseHTMLString: true,
            //   confirmButtonClass: "confirm-style",
            //   showCancelButton: false,
            // });
          }
        })
        .catch((error) => {});
    },
    queryUavModel() {
      let vue = this;
      this.getRequest("/basic-info-server/uavmodel/getAllUavModelList.do")
        .then((res) => {
          res = res.data;
          if (null != res && 0 == res.code) {
            if (!this.isEmptyArray(res.data)) {
              this.$data.uavModels = res.data;
            } else {
              this.$data.uavModels = [];
            }
          } else if (res.code != 401) {
            // let msg = "请求数据失败";
            // if (!this.isEmptyStr(res.msg)) {
            //   msg = res.msg;
            // }
            // let tips = "<i class='el-icon-warn-tip'></i>" + msg;
            // this.$confirm(tips, "提示", {
            //   confirmButtonText: "好的",
            //   customClass: "customClass-style",
            //   iconClass: "",
            //   dangerouslyUseHTMLString: true,
            //   confirmButtonClass: "confirm-style",
            //   showCancelButton: false,
            // });
          }
        })
        .catch((error) => {});
    },
    queryAirborneCommunication() {
      let vue = this;
      this.getRequest(
        "/basic-info-server/airbornecommunction/getAllAirBorneCommunctioList.do"
      )
        .then((res) => {
          res = res.data;
          if (null != res && 0 == res.code) {
            if (!this.isEmptyArray(res.data)) {
              this.$data.airborneCommunications = res.data;
            } else {
              this.$data.airborneCommunications = [];
            }
          } else if (res.code != 401) {
            // let msg = "请求数据失败";
            // if (!this.isEmptyStr(res.msg)) {
            //   msg = res.msg;
            // }
            // let tips = "<i class='el-icon-warn-tip'></i>" + msg;
            // this.$confirm(tips, "提示", {
            //   confirmButtonText: "好的",
            //   customClass: "customClass-style",
            //   iconClass: "",
            //   dangerouslyUseHTMLString: true,
            //   confirmButtonClass: "confirm-style",
            //   showCancelButton: false,
            // });
          }
        })
        .catch((error) => {});
    },
    queryUsers() {
      let vue = this;
      this.postJsonRequest(
        "/user-server/api/u-user/queryByDepartmentIdAndRoleName",
        {
          roleName: "飞机维护员",
          removed: 0,
        }
      )
        .then((res) => {
          res = res.data;
          if (null != res && 0 == res.code) {
            if (!this.isEmptyArray(res.data)) {
              this.$data.users = res.data;
            } else {
              this.$data.users = [];
            }
          } else if (res.code != 401) {
            // let msg = "请求数据失败";
            // if (!this.isEmptyStr(res.msg)) {
            //   msg = res.msg;
            // }
            // let tips = "<i class='el-icon-warn-tip'></i>" + msg;
            // this.$confirm(tips, "提示", {
            //   confirmButtonText: "好的",
            //   customClass: "customClass-style",
            //   iconClass: "",
            //   dangerouslyUseHTMLString: true,
            //   confirmButtonClass: "confirm-style",
            //   showCancelButton: false,
            // });
          }
        })
        .catch((error) => {});
    },
    queryDepartment() {
      let vue = this;
      this.postJsonRequest("/user-server/api/u-department/query?size=-1", {
        removed: 0,
      })
        .then((res) => {
          res = res.data;
          if (null != res && !this.isEmptyArray(res.data.records)) {
            if (null != res.data) {
              this.$data.departments = res.data.records;
            } else {
              this.$data.departments = [];
            }
          } else if (res.code != 401) {
            // let msg = "请求数据失败";
            // if (!this.isEmptyStr(res.msg)) {
            //   msg = res.msg;
            // }
            // let tips = "<i class='el-icon-warn-tip'></i>" + msg;
            // this.$confirm(tips, "提示", {
            //   confirmButtonText: "好的",
            //   customClass: "customClass-style",
            //   iconClass: "",
            //   dangerouslyUseHTMLString: true,
            //   confirmButtonClass: "confirm-style",
            //   showCancelButton: false,
            // });
          }
        })
        .catch((error) => {});
    },
    query() {
      let vue = this;
      this.getRequest(
        "/basic-info-server/uav/getUavList.do?pagesize=" +
          this.$data.size +
          "&currentpage=" +
          this.$data.current +
          this.getQueryParam()
      )
        .then((res) => {
          res = res.data;
          if (null != res && 0 == res.code) {
            if (null != res.data && !this.isEmptyArray(res.data.list)) {
              this.$data.totalCount = res.data.total;
              this.$data.tableData = res.data.list;
            } else {
              this.$data.totalCount = 0;
              this.$data.tableData = [];
            }
          } else if (res.code != 401) {
            // let msg = "请求数据失败";
            // if (!this.isEmptyStr(res.msg)) {
            //   msg = res.msg;
            // }
            // let tips = "<i class='el-icon-warn-tip'></i>" + msg;
            // this.$confirm(tips, "提示", {
            //   confirmButtonText: "好的",
            //   customClass: "customClass-style",
            //   iconClass: "",
            //   dangerouslyUseHTMLString: true,
            //   confirmButtonClass: "confirm-style",
            //   showCancelButton: false,
            // });
          }
        })
        .catch((error) => {});
    },
    //编辑
    edit(row) {
      this.doEdit(row.id);
    },
    doEdit(id) {
      let vue = this;
      this.postJsonRequest("/basic-info-server/uav/getUavById.do", {
        id: id,
      })
        .then((res) => {
          res = res.data;
          if (null != res && 0 == res.code) {
            if (null != res.data) {
              this.$data.title = "修改飞机";
              this.queryAllTypeInfos();
              this.$data.addFlag = false;
              if (res.data.area_id && res.data.station_id) {
                res.data.area_station = [
                  parseInt(res.data.area_id),
                  parseInt(res.data.station_id),
                ];
              }
              this.$data.commonForm = res.data;
              this.$data.dialogVisible = true;
            } else {
              // let tips =
              //   "<i class='el-icon-warn-tip'></i> 啊哦,请求数据不存在~";
              // this.$confirm(tips, "提示", {
              //   confirmButtonText: "好的",
              //   customClass: "customClass-style",
              //   iconClass: "",
              //   dangerouslyUseHTMLString: true,
              //   confirmButtonClass: "confirm-style",
              //   showCancelButton: false,
              // });
            }
          } else if (res.code != 401) {
            // let msg = "请求数据失败";
            // if (!this.isEmptyStr(res.msg)) {
            //   msg = res.msg;
            // }
            // let tips = "<i class='el-icon-warn-tip'></i>" + msg;
            // this.$confirm(tips, "提示", {
            //   confirmButtonText: "好的",
            //   customClass: "customClass-style",
            //   iconClass: "",
            //   dangerouslyUseHTMLString: true,
            //   confirmButtonClass: "confirm-style",
            //   showCancelButton: false,
            // });
          }
        })
        .catch((error) => {});
    }, //编辑提交
    editStayPoint() {
      let vue = this;
      this.postJsonRequest(
        "/basic-info-server/uav/upateUav.do",
        this.$data.commonForm
      )
        .then((res) => {
          res = res.data;
          if (null != res && 0 == res.code) {
            vue.$data.dialogVisible = false;
            vue.query();
            vue.$message({
              message: "提交成功",
              duration: 1000,
              customClass: "message-s",
              iconClass: "el-icon-ok-tip",
              offset: 470,
              onClose: function () {},
            });
          } else if (res.code != 401) {
            let msg = "请求失败";
            if (null != res) {
              msg = res.msg;
            }
            let tips = "<i class='el-icon-warn-tip'></i>" + msg;
            this.$confirm(tips, "提示", {
              confirmButtonText: "好的",
              customClass: "customClass-style",
              iconClass: "",
              dangerouslyUseHTMLString: true,
              confirmButtonClass: "confirm-style",
              showCancelButton: false,
            });
          }
        })
        .catch((error) => {});
    }, //删除
    del(row) {
      let tips =
        "<i class='el-icon-warn-tip'></i>将永久删除该条记录, 是否继续?";
      this.$confirm(tips, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        customClass: "customClass-style",
        iconClass: "",
        dangerouslyUseHTMLString: true,
        confirmButtonClass: "confirm-style",
        cancelButtonClass: "cancel-style",
      })
        .then(() => {
          this.doDel(row);
        })
        .catch(() => {});
    },
    doDel(row) {
      let vue = this;
      this.postJsonRequest("/basic-info-server/uav/DelUav.do", row)
        .then((res) => {
          res = res.data;
          if (null != res && 0 == res.code) {
            let totalPage = Math.ceil((this.totalCount - 1) / this.size);
            let currentPage =
              this.current > totalPage ? totalPage : this.current;
            this.current = currentPage < 1 ? 1 : currentPage;
            vue.query();
            vue.$message({
              message: "删除成功",
              duration: 1000,
              customClass: "message-s",
              iconClass: "el-icon-ok-tip",
              offset: 470,
              onClose: function () {},
            });
          } else if (res.code != 401) {
            let msg = "请求失败";
            if (null != res) {
              msg = res.msg;
            }
            let tips = "<i class='el-icon-warn-tip'></i>" + msg;
            this.$confirm(tips, "提示", {
              confirmButtonText: "好的",
              customClass: "customClass-style",
              iconClass: "",
              dangerouslyUseHTMLString: true,
              confirmButtonClass: "confirm-style",
              showCancelButton: false,
            });
          }
        })
        .catch((error) => {});
    }, //分页函数
    handleSizeChange: function (val) {
      this.size = val;
      this.query();
    },
    handleCurrentChange: function (current) {
      this.current = current;
      this.query();
    },
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid && this.$data.addFlag) {
          this.addStayPoint();
        } else if (valid && !this.$data.addFlag) {
          this.editStayPoint();
        } else {
          return false;
        }
      });
    },
  },
  watch: {
    dialogVisible: function (nval, oval) {
      if (!nval) {
        this.$data.commonForm = {};
      }
      this.defaultClearValidate();
    },
  },
};
</script>

<style scoped>
.mainCommonListContainer {
  width: 100%;
  height: 100%;
}
</style>
<style>
.adminHomeContainer
  .el-tabs
  .el-tabs__content
  #pane-planeList
  .commonDialog
  .el-dialog {
  margin-top: calc(25% - 312px) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/plane/plane/plane.vue